module.exports = __webpack_public_path__ + "media/images/time@2x-024f21e8f5bbdf8ddd5dd91603f70bfa.png";